<template>
  <Spinner v-if="isLoading" />
  <Toast />
        <ConfirmDialog></ConfirmDialog>
        <ConfirmDialog group="templating">
                <template #message="slotProps">
                    <div class="flex p-4">
                        <i :class="slotProps.message.icon" style="font-size: 1.5rem"></i>
                        <p class="pl-2">{{slotProps.message.message}}</p>
                    </div>
                </template>
        </ConfirmDialog>
        <ConfirmDialog group="positionDialog"></ConfirmDialog>
  <div class="grid">        	    
    <div class="card col-12 mainTitle">
        <h3 class="stationsHeader">{{ translated('newhomevisit').toUpperCase() }}</h3>                
    </div>

      <div class="homevisit-view card col-12 md:col-6">
        <div class="card col-12 mainTitle">
          <h3 class="stationsHeader">{{ translated('basicInfo').toUpperCase() }}</h3>
        </div> 

        <div v-if="!displayModalUser" class="p-fluid grid elementGroup">
          <div class="col-12 sm:col-5">
            <label :class="{'p-error':v$.selectedPerson.$invalid && submitted}">{{ translated('person') }} </label>
          </div>                
          <div class="col-12 sm:col-7 childUsers">
            <!-- <Dropdown @change="personChange" panelStyle="style='Class=TestTest'" panelClass="childPersons" v-model="selectedPerson" :options="PersonOptions" optionLabel = "label" optionValue = "value" placeholder="Izaberite osobu" id="person"> -->
              <Dropdown @change="personChange" v-model="selectedPerson" :options="PersonOptions" optionLabel = "label" optionValue = "value" :placeholder=this.selectedPersonPlaceholder id="person">
                <template #option="slotProps">
                    <div class="country-item">                        
                        <div class="ComboLastRow">{{slotProps.option.label}}</div>
                    </div>
                </template>
              </Dropdown>
          </div>
        </div>

        <div v-else class="p-fluid grid elementGroup">
          <div class="col-12 sm:col-5">
            <label>{{ translated('person') }} </label>
          </div>                   
          <div class="col-12 sm:col-7">
            <Dropdown v-model="selectedPerson" :options="PersonOptions" optionLabel = "label" optionValue = "value" :placeholder="translated('choosePerson')" id="person"/>
          </div>
        </div>

        <div v-if="!displayModalUser" class="p-fluid grid elementGroup">          
          <div class="col-12 sm:col-5">
            <label :class="{'p-error': v$.homeVisitDate.$invalid && submitted}">{{ translated('requestdate') }} </label>
          </div>              
          <div class="col-12 sm:col-7">
            <Calendar :label="translated('homeVisitDate')" inputId="icon" v-model="homeVisitDate" :showIcon="true" dateFormat="dd-mm-yy" :minDate="new Date()"/>  
          </div>                         
        </div>
        <div v-else class="p-fluid grid elementGroup">
          <div class="col-12 sm:col-5">
            <label>{{ translated('requestdate') }} </label>
          </div>            
          <div class="col-12 sm:col-7">
            <Calendar :label="translated('homeVisitDate')" i inputId="icon" v-model="homeVisitDate" :showIcon="true" dateFormat="dd-mm-yy" :minDate="new Date()"/>  
          </div>                         
        </div>
        
        <div v-if="!displayModalUser" class="p-fluid grid elementGroup">
          <div class="col-12 sm:col-5">
            <label :class="{'p-error': v$.homeVisitTimeFrom.$invalid && submitted}">{{ translated('homeVisitTimeFrom') }}</label>
          </div>
              
          <div class="col-12 sm:col-7">
            <!-- <Calendar inputId="homeVisitTime" v-model="homeVisitTimeFrom" :showTime="true" :timeOnly="true" :hourFormat=24 />  -->
            <TimePickerBiomedica :homeVisitDate = "homeVisitDate" class="timecontrolFrom" :timeStartInt="computedFrom" @timeChanged="startChanged"/>
          </div>
        </div>
        <div v-else class="p-fluid grid elementGroup">
          <div class="col-12 sm:col-5">
            <label>{{ translated('homeVisitTimeFrom') }}</label>
          </div>            
          <div class="col-12 sm:col-7">
            <!-- <Calendar inputId="homeVisitTime" v-model="homeVisitTimeFrom" :showTime="true" :timeOnly="true" :hourFormat=24 />  -->
            <TimePickerBiomedica :homeVisitDate = "homeVisitDate" class="timecontrolFrom" :timeStartInt="computedFrom" @timeChanged="startChanged"/>
          </div>
        </div>
        
        <div v-if="!displayModalUser" class="p-fluid grid elementGroup">
          <div class="col-12 sm:col-5">
            <label :class="{'p-error': v$.homeVisitTimeTill.$invalid && submitted}">{{ translated('homeVisitTimeTill') }}</label>
          </div>              
          <div class="col-12 sm:col-7">
            <!-- <Calendar inputId="homeVisitTime" v-model="homeVisitTimeTill" :showTime="true" :timeOnly="true" :hourFormat=24 />  -->
            <TimePickerBiomedica :homeVisitDate = "homeVisitDate" class="timecontrolTill" :timeStartInt="computedTill" @timeChanged="tillChanged"/> 
          </div>
        </div>
        <div v-else class="p-fluid grid elementGroup">
          <div class="col-12 sm:col-5">
            <label>{{ translated('homeVisitTimeTill') }}</label>
          </div>            
          <div class="col-12 sm:col-7">
            <!-- <Calendar inputId="homeVisitTime" v-model="homeVisitTimeTill" :showTime="true" :timeOnly="true" :hourFormat=24 />  -->
            <TimePickerBiomedica :homeVisitDate = "homeVisitDate" class="timecontrolTill" :timeStartInt="computedTill" @timeChanged="tillChanged"/> 
          </div>
        </div>
        
        <div class="p-field grid elementGroup">
          <div class="col-12 sm:col-5">
            <label>{{ translated('clientnotes') }} </label>
          </div>            
          <div class="col-12 sm:col-7">
              <textarea class="textBox" type="text" v-model="clientNotes"/>
          </div>                         
        </div>


        <div class="p-fluid grid elementGroup">
          <div class="col-12 sm:col-6 labeldiv">
            <div class="col-6 sm:col-12 col-offset-3  sm:col-offset-6" >
                <div class="p-fluid-button" id="requestbutton">
                    <div class="col-12 submitplaceholder" :hidden="enabledfield">
                      <Button v-if="conditionalAnalysisDisplay(analysis)" class="submitbtn" :label="translated('editAnalysis')" icon="pi pi-pencil" @click="editAnalysis()"/>
                      <Button v-else class="submitbtn" :label="translated('addAnalysis')" icon="pi pi-plus-circle" @click="addNewAnalysis()"/>          
                    </div>	
                </div>											
            </div>
          </div>
        </div>
        <div v-if="conditionalAnalysisDisplay(analysis)" class="analysis-elements card col-12">
          <div class="card col-12 mainTitle">
            <!-- <h3 class="stationsHeader">ELEMENTI ANALIZE</h3> -->
            <h3 class="stationsHeader">{{ translated('analysisElements').toUpperCase() }}</h3>
          </div>
          <DataTable class="selectedAnalysisTable" :value="analysisItemsForTable" stripedRows tableStyle="width: 100%">
            <Column field="name" header="Naziv">
              <template #body="slotProps">
                {{slotProps.data.name}}
                
              </template>
            </Column>
            
            <Column field="price" header="Cena">
              <template #body="slotProps">
                {{ formatCurrency(slotProps.data.price) }}
              </template>
            </Column>
          </DataTable>
          <div class="grid totalPriceFrame">
            <div class="col-12 priceTotal">{{ formatCurrency(analysisTotalPrice) }}</div>
          </div>
        </div>
      </div>
      <div class="homevisit-view-right card col-12 md:col-6">
        <div class="card col-12 mainTitle">
          <h3 class="parent-messages-header">{{ translated('messages').toUpperCase() }}</h3>
        </div>
      </div>

      <div class="card col-12">
        <div class="checkConditions"><Checkbox v-model="checkedConditions" :binary="true" /></div>
        <div id="usloviPatronaze">* Operator će da doda cenu dolazka. Cena zavisi od vaše lokacije. Od 0-3km od centra grada cena je xxx RSD, od 3 - 15km cena je YYY RSD. Konačna cena se vidi nakon obostranog potvrđivanja termina. Kad je termin potvrđen ona možete patronažu sa analizama i da platite (nije obavezno, plačanje može da se uradi i kod dolazka patronaže)</div>
      </div>      

      <div class="card col-12">

        <div class="flex justify-content-center flex-wrap card-container">
          <div class="flex align-items-center justify-content-center">
            <Button class="submitbtn" :disabled="!checkedConditions" label="Pošaljite zahtev" @click="confirm()"/>            
          </div>
          
        </div>
        
      </div>
      
    </div>
    <Dialog class="modal-profile" :header="translated('insertNewUser')" v-model:visible="displayModalUser" modal :breakpoints="{'960px': '75vw', '640px': '90vw'}" :style="{width: '50vw'}">
      <div class="grid">  
        <Person ref="personModal" @saved="childSaved"></Person>
      </div> 
      <template #footer>
        <div class="modal-buttons">
          <Button :label="translated('insertUser')" icon="pi pi-check" @click="saveChild()" class="submitbtn" />
          <Button :label="translated('goBack')" icon="pi pi-times" @click="displayModalUser=false" autofocus class="submitbtn" />
        </div>
      </template>
    </Dialog>
  </template>
<script>
import createHttp from "@/services/http";
import router from "@/router/index";
import { computed } from "vue"
import store from "@/store";
import Spinner from "@/components/Spinner.vue";
import Calendar from 'primevue/calendar';
import Dropdown from 'primevue/dropdown';
import { required, email, numeric, minLength, maxLength, } from "@vuelidate/validators";
import { useVuelidate } from "@vuelidate/core";
import TimePickerBiomedica from '@/components/TimePickerBiomedica.vue';
import DataTable from 'primevue/datatable';
import Column from 'primevue/column';
import Person from '@/components/Person.vue';

export default {
    components: { Spinner, 
                  Calendar,
                  Dropdown,
                  TimePickerBiomedica,
                  DataTable,
                  Column,
                  Person
                },
    props: ['aid'],
    setup: () => ({ v$: useVuelidate() }),
    computed: {
      computedFrom (){
            return this.homeVisitTimeFrom
        },
        computedTill (){          
            return this.homeVisitTimeTill
        }
    },
    data() {
      return {
        translated: computed(() => store.getters.getTranslate),
        // name: [],
        // surname: [],
        initHour: 8,
        id: null,
        analysis: null,
        homeVisitDate: null,
        homeVisitTimeFrom: null,
        homeVisitTimeTill: null,
        additionalInfo: null,
        clientNotes:null,
        personList:[],
        selectedPerson: null,
        // personName:[],
        // personSurname:[],
        personId: [],
        PersonOptions: [],
        submitted: false,
        displayModalUser: false,
        Errors: [],
        IsDirty: true,
        // name: '',
        // surname:'',
        // personalregistrationnumber: '',
        // email:'',
        // address:'',
        // zip:'',
        // city:'',            
        // mobilephone:'',
        // countries: [],
        // selectedCountry: '',
        submittedModal: false,
        parentpersonid:'',
        dateinserted:'',
        displayModalText:false,
        initFrom: null,
        initTill: null,
        selectedPersonPlaceholder: 'Izaberite osobu',
        homeVisitSaved: false,
        parentName: '',
        genders: [{ id: 0, name: 'Muško' }, { id: 1, name: 'Žensko' }],
        gender: '',
        isLoading: false,
        ownerPersonId: computed(() => store.getters.getUserId),
        analysisItemsForTable: [],
        analysisTotalPrice: null,
        analysisRequestId: null,
        checkedConditions: false 
      }
      
    },
    validations() {              
        let myvalidations = {
          selectedPerson:{ required }, 
          homeVisitDate: { required, 
                          isDate(value) {
                          // console.log(Date.parse((value)) + " 444444444444444444444444444444444444444444444444444444444444444");
                          return !isNaN(Date.parse(value));
                        }
          },
          homeVisitTimeFrom: { required },
          homeVisitTimeTill: { required, 
                              isAfterTimeFrom(value, {homeVisitTimeFrom}) {
                                // console.log(new Date(value).getTime());
                                // console.log(new Date(homeVisitTimeFrom).getTime());
                                return !(new Date(value).getTime()<=new Date(homeVisitTimeFrom).getTime())
            } 
          }
        };
        let myModalValidations = {
          name: {  required },
          surname: { required },
          personalregistrationnumber: { minLength: minLength(13), maxLength: maxLength(13), required },
          email:{ required, email },
          address:{ required },
          zip: { minLength: minLength(5), maxLength: maxLength(5), required },
          city: { required },            
          mobilephone: { required },
          selectedCountry: {required, minLength: minLength(10) },
          parentName: { required },
          gender: { required }
        };
        if(this.displayModalUser)
        {
            return myModalValidations;
        };
        return myvalidations;
    },
    created() {
      this.initFrom=60;
      this.initTill=90;
    },
    async mounted() {      
      this.initTill=1200; 
      this.initFrom=450;
      this.isLoading = true;
      
      const storedFormClientNotes = sessionStorage.getItem('clientNotes');
      const storedFormPersonId = sessionStorage.getItem('personId');
      const storedFormHomeVisitDate = sessionStorage.getItem('hvDate');

      // console.log(storedFormHomeVisitDate);
      // console.log(this.ownerPersonId);

      const storedFormHomeVisitTimeFrom = sessionStorage.getItem('fromTime');
      const storedFormHomeVisitTimeTill = sessionStorage.getItem('tillTime');
      // console.log(storedFormPersonId + " " + storedFormHomeVisitDate + " " + storedFormHomeVisitTimeFrom + " " + storedFormHomeVisitTimeTill + " " + storedFormClientNotes);
      if (storedFormClientNotes) {
        this.clientNotes = JSON.parse(storedFormClientNotes);
      }
      if (storedFormHomeVisitDate) {
        //this.homeVisitDate = this.makeDateString(JSON.parse(storedFormHomeVisitDate));
        this.homeVisitDate = this.makeDateOutOfSession(JSON.parse(storedFormHomeVisitDate));
        // console.log(this.homeVisitDate);
      }
      if (storedFormHomeVisitTimeFrom) {
        this.initFrom = JSON.parse(storedFormHomeVisitTimeFrom);
      }
      if (storedFormHomeVisitTimeTill) {
        this.initTill = JSON.parse(storedFormHomeVisitTimeTill);
      }
      if (storedFormPersonId) {
        this.selectedPerson = JSON.parse(storedFormPersonId);
      }
        debugger;
        const http = createHttp(true);
        // console.log('ZOVEM API PERSONWITHCHILDREN************************************************************************************')
        const result = await http.get(process.env.VUE_APP_API_FOLDER + "/getPersonWithChildren?all=true");
        // console.log(result)

        debugger;
        if(result.status==401) {
            store.dispatch("logout");
        }

        if(result.status == 200){
            this.PersonOptions=[];
            debugger;
            for (let x in result.data) {
              this.PersonOptions.push(
              {label:result.data[x].name + " " + result.data[x].surname, value: result.data[x].id}
            )};
            this.PersonOptions.push({label: this.translated('addPerson'), value: "other", class:"nesto-novo"});
            // console.log(storedFormPersonId);
            
            if (storedFormPersonId !== null) { //POKUSAO NEKAKO DA PRIKAZEM ODABRANU OSOBU ALI IMAM PROBLEM, NE ZNAM DA LI DA JE STAVLJAM KAO PLACEHOLDER U NEKU FUNKCIJU ILI STA
              // console.log(storedFormPersonId);
              // console.log(this.PersonOptions); 
              let sessionPerson = this.PersonOptions.find(x => x.value == this.ownerPersonId);
              this.selectedPersonPlaceholder = sessionPerson.label;
            }
        }
      
      // this.loadCountries();

      debugger;
      // Proverim ako hvid nije empty guid. Ako nije loudujem analizu sa tim guidom i prikazujemo elemente analize i sumu.
      if(this.isValidGuid(this.aid) && !this.isEmptyGuid(this.aid)) {
        // Potrebno je naložiti podatke da lahko prikažemo analize, ki so bile izbrane        
        // console.log(this.aid +"   ////////////////////////////////////////////////////////////////////////////////////////////"); 
        const result = await http.get(process.env.VUE_APP_API_FOLDER + "/GetAnalysisRequest" + "?id=" + this.aid);
        this.analysis = result.data;
        // console.log(result);
        // console.log('VSE ANALIZE ZA Home VISIT');
        this.analysisItemsForTable = this.analysis.analysisItems;
        this.analysisTotalPrice = this.analysis.totalPrice;
        this.analysisRequestId = this.analysis.id;
        // console.log(this.analysis);
        // console.log(this.analysisItemsForTable);
      }

      this.isLoading = false;
    },
    beforeRouteLeave(to, from, next) {
      debugger;
      this.saveFormToSessionStorage();
      if (this.homeVisitSaved) {
        sessionStorage.clear();
      }
      // console.log(sessionStorage);
      next();
    },
    methods: {
      async childSaved(savedperson) {
          debugger;
          this.displayModalUser=false;     
          // Sedaj bi moral to Insertat v Combo in ga nastaviti na ta na novo insertan zapis            
          this.PersonOptions.unshift({label: savedperson.name + " " + savedperson.surname, value: savedperson.id});
          this.selectedPerson = savedperson.id;
          debugger;
      },
      saveChild() {
          this.$refs.personModal.Save();
      },
      addNewAnalysis() {
        this.saveFormToSessionStorage();
        this.$router.push({ name: 'NewAnalysis', params: { id: '00000000-0000-0000-0000-000000000000', source:'homevisit', linked: true, homevisitid: '00000000-0000-0000-0000-000000000000' } });
      },
      isValidGuid(guid) {
          const guidRegex = /^[0-9a-f]{8}-[0-9a-f]{4}-4[0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
          const emptyGuid = '00000000-0000-0000-0000-000000000000';
          return guidRegex.test(guid) && guid !== emptyGuid;
      },      
      isEmptyGuid(guid) {
          return '00000000-0000-0000-0000-000000000000' == guid;
      },      
      async handleSubmit(isFormValid) {
          this.submitted = true;
          if (!isFormValid) {
              return;
          }

          this.Errors = [];
          this.IsDirty = false;
          // console.log('klicem submit')

          let analysisRequestId = null;

          if(this.analysis != null) {
            analysisRequestId = this.analysis.id;
          }

          let homeVisit = {
              PersonId:this.selectedPerson,
              AnalysisRequestId: analysisRequestId, //za sada
              RequestedDate:this.formatDateQalendar(this.homeVisitDate),
              AgreedDate: null,
              ClientNotes: this.clientNotes,
              Status: 0,
              TimeFrom: this.homeVisitTimeFrom,//this.getHours((this.formatTime(this.homeVisitTimeFrom))) * 60 + this.getMinutes((this.formatTime(this.homeVisitTimeFrom))),
              TimeTill: this.homeVisitTimeTill,//this.getHours((this.formatTime(this.homeVisitTimeTill))) * 60 + this.getMinutes((this.formatTime(this.homeVisitTimeTill))),
              AgreedTimeFrom: null,
              AgreedTimeTill: null,
              Messages: null,
              Name: null,
              Surname:null
          }
          const http = createHttp(true); 
          try {
              http.post(process.env.VUE_APP_API_FOLDER + "/SaveHomeVisit", homeVisit)
                  .then((response) => { 
                      // console.log('OK response');
                      // console.log(response);
                      // console.log(sessionStorage);
                      
                      this.isLoading = true;
                      this.homeVisitSaved = true;
                      this.$toast.add({severity:'info', summary:this.translated('confirmation'), detail:this.translated('youMadeNewHomeVisit'), life: 2000});
                      setTimeout(() => {
                            this.isLoading = false;
                            router.push("/");
                        }, 3000);
                      
                  })
                  .catch((error) => {
                      const myErr = {...error};

                      // console.log('ERROR');
                      // console.log(myErr) 
                      this.Errors = myErr.response.data.Errors;
                      
                      
              })
          } 
          catch (error) {
              // console.log(error);
          }
      },
      startChanged(data, timeInt) {        
        this.homeVisitTimeFrom = timeInt;
        
          if(this.homeVisitTimeFrom >= this.homeVisitTimeTill) {
              this.homeVisitTimeTill = this.homeVisitTimeFrom + 30; //15
          }

      },
      tillChanged(data, timeInt) {
          this.homeVisitTimeTill = timeInt;
          if(this.homeVisitTimeTill <= this.homeVisitTimeFrom) {
              this.homeVisitTimeFrom = this.homeVisitTimeTill - 30; //15
          }
      },
      personChange(e) {
        // console.log('Selected value guid: ' + e.value);
        if (e.value === 'other') {          
          this.displayModalUser=true;          
          this.$nextTick(() => {
              this.$refs.personModal.Clear();
              this.$refs.personModal.UnlockAll();
          }); 
        }
      },
      formatTime(value){
        // console.log(value+"------------------------------------------------------------------")
        let newDate = new Date(Date.parse(value));
        
        var hoursMinutes = newDate.getHours().toString() + ":" + newDate.getMinutes().toString();
        // console.log(hoursMinutes+"------------------------------------------------------------------")
        return hoursMinutes;
      },
      getHours(value){
        // console.log(value + "getHours------------------------------------------------------------------")
        let hourminute =  value.split(':');
        return  parseInt(hourminute[0]);
      },
      getMinutes(value){
        // console.log(value + "getMinutes------------------------------------------------------------------")
        let hourminute =  value.split(':');
        return  parseInt(hourminute[1]);
      },
      formatDate(value) {
        let myDate = new Date(value);

        return myDate.toLocaleDateString('ro-Ro');
      },
      formatDateQalendar(value) {
        // console.log(value);
            if(value != null){
                let tmpMyDate = new Date(value);
                const year = tmpMyDate.getFullYear();
                const month = String(tmpMyDate.getMonth() + 1).padStart(2, '0');
                const day = String(tmpMyDate.getDate()).padStart(2, '0');
                const formattedDate = `${year}-${month}-${day}`;

                return formattedDate;
            }
      },
      async handleInsertCustomTextMessage() {
        this.isLoading = true;
        this.Errors = [];
        // console.log('klicem insert')

          let insertCustomHomeVisitMessage = {
              //id:this.uguid,  
              homevisitid:this.homevisit.id,
              personid:this.homevisit.personId,
              //person: null,
              message:this.messageText,
              messageDate: new Date(),
              suggestedDate: null,
              suggestedTimeFrom: 0,
              suggestedTimeTill: 0,
              suggestedDateAgreedDisagreed: null,
              agreed: false,
              disagreed: false,
              responded: false,
              messageRead: false,
              messageReadDate: null,
              operatorId: null,
              //operator: null,
              messageType: 0
          }
          const http = createHttp(true); 
          try {
              http.post(process.env.VUE_APP_API_FOLDER + "/insertCustomHomeVisitMessage", insertCustomHomeVisitMessage)
                  .then((response) => { 
                      // console.log('OK response');
                      // console.log(response);
                      router.push("/");
                  })
                  .catch((error) => {
                      const myErr = {...error};

                      // console.log('ERROR');
                      // console.log(myErr) 
                      this.Errors = myErr.response.data.Errors;                                            
              })
          } 
          catch (error) {
              // console.log(error);
          }
          this.isLoading = false;
      },
      saveFormToSessionStorage() {
        debugger;

        sessionStorage.setItem('clientNotes', JSON.stringify(this.clientNotes));
        sessionStorage.setItem('personId', JSON.stringify(this.selectedPerson));
        sessionStorage.setItem('tillTime', JSON.stringify(this.homeVisitTimeTill));
        sessionStorage.setItem('fromTime', JSON.stringify(this.homeVisitTimeFrom));
        // console.log(this.homeVisitDate);
        sessionStorage.setItem('hvDate', JSON.stringify(this.homeVisitDate));
      },
      makeDateOutOfSession(value) {
        debugger;
        if (value == null) {
          return null;
        }
        const date = new Date(value);
        
        return date;//madeDateOutOfSession;
      },
      makeDateString(value) {
        debugger;
        const gmtOffsetMs = 2 * 60 * 60 * 1000;
        const parts = value.split("-");
        let year = parseInt(parts[2]);
        let month = parseInt(parts[1]) - 1;
        let day = parseInt(parts[0]);

        const timeValue = Date.UTC(year, month, day, 0, 0, 0) + gmtOffsetMs;
        const madeDate = new Date(timeValue);
        // console.log(madeDate);
        day = madeDate.getDate().toString().padStart(2, '0');
        month = (madeDate.getMonth() + 1).toString().padStart(2, '0');
        year = madeDate.getFullYear();

        const formattedDate = `${day}-${month}-${year}`;
        return formattedDate;
      },
      confirm(event) {
        this.submitted = true;
        if (this.v$.$invalid) {
            return;
        };
        this.$confirm.require({
            message: this.translated('wantAgreeHomeVisit'),
            header: this.translated('confirmation'),
            icon: 'pi pi-exclamation-triangle',
            acceptLabel: this.translated('yes'),
            rejectLabel: this.translated('no'),
            accept: () => {
                // await this.hand
                this.isLoading = true;
                this.handleSubmit(true);
                // this.$toast.add({severity:'info', summary:'Potvrđeno', detail:'Sačuvali ste izmene', life: 3000});
            },
            reject: () => {
                this.$toast.add({severity:'error', summary:this.translated('declined'), detail:this.translated('youDidNotAgreeHomeVisit'), life: 3000});
            }
        });
      },
      conditionalAnalysisDisplay(value) {
        if (value != null || value != undefined) {
          return true;
        }
        return false;
      },
      formatCurrency(amount){
        debugger;
        if(amount != null){
          const formattedAmount = amount.toLocaleString('rs-RS', {
            style: 'currency',
            currency: 'RSD',
          });
          return formattedAmount.replace(/(^\D*)([\d,.]*)(\D*$)/, "$2 $1").trim();
        }
          
          // return formattedAmount.replace(/(^\D*)(\d.*\d)(\D*$)/, '$2 $1').trim();
      },
      editAnalysis(){
        
        if(this.isValidGuid(this.analysisRequestId) && !this.isEmptyGuid(this.analysisRequestId)) {
          router.push({ name: 'NewAnalysis', params: { id: this.analysisRequestId, homevisitid: this.id, source:'newhomevisit', linked: true  } });
        }       
      },
      timePickerDisabled(){
        debugger;  
        // console.log(this.homeVisitDate);
        if(this.homeVisitDate == null){
            return true;
          }
          return false;
      }
    },
}
</script>

<style scoped>


.textBox{
  height: 100px;
  width: 100%;
}

.parent-messages-header, .message-header{
  display: flex;
}

textarea.textBox { border-color: #ced4da;}

.nesto-novo{
  background-color: aqua;
}
.modal-buttons{
  text-align: center;
  display: flex;
  justify-content: center;
}

.timecontrolFrom {position:relative; float:left; }
.timecontrolTill {position:relative; float:Right; }
/deep/ .p-datatable .p-datatable-tbody > tr > td:nth-child(2)  { text-align:right; }

/deep/ .p-datatable .p-datatable-thead > tr > th:nth-child(2) div {    
    float:right;
    position:relative;
    display:block;
}

.priceTotal {
    text-align: right;
    font-weight: bold;
    font-size: 1.3em;
    padding-right: 20px;
}

.grid.totalPriceFrame {
    margin-top: 10px;
    border-top: solid 2px darkgrey;
}

div#usloviPatronaze {
    font-style: italic;
    color:rgb(134, 70, 70);
}

.checkConditions {width: 30px;position: relative;float: left;height: 40px;}

textarea {resize: none;}

</style>